import axios from '../axios'

export const selectByPage = (data) => {
    return axios({
        url: '/admin/feedback/selectByPage',
        method: 'post',
        data
    })
}

export const insert = (data) => {
    return axios({
        url: '/admin/feedback/insert',
        method: 'post',
        data
    })
}

export const update = (data) => {
    return axios({
        url: '/admin/feedback/update',
        method: 'post',
        data
    })
}

export const batchDelete = (data) => {
    return axios({
        url: '/admin/feedback/batchDelete',
        method: 'post',
        data
    })
}

export const batchReply = (data) => {
    return axios({
        url: '/admin/feedback/batchReply',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/feedback.js